import React, { useState } from 'react';
import { SingleButtonStyled } from './styles';
import {
  Button, Dialog, DialogActions, DialogTitle, FormGroup,
} from '@mui/material';

function SingleButton({
  children, isDeleteButton, onClick, dialogMessage, icon, ...rest
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  function DeleteDialog() {
    return (
      <FormGroup>
        <Dialog open={open} onClose={handleClose} aria-labelledby="alert">
          <DialogTitle id="alert">{dialogMessage}</DialogTitle>
          <DialogActions style={{ padding: '0rem 1.5rem 1.5rem 0rem' }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              style={{
                border: '1px solid red',
                color: 'red',
              }}
            >
              Não
            </Button>
            <Button
              onClick={() => {
                onClick();
                return handleClose();
              }}
              style={{
                backgroundColor: '#0267C1',
                color: 'white',
              }}
            >
              Sim
            </Button>
          </DialogActions>
        </Dialog>
      </FormGroup>
    );
  }

  return (
    <>
      <SingleButtonStyled
        startIcon={icon}
        onClick={!isDeleteButton ? onClick : handleClickOpen}
        {...rest}
      >
        {children}
      </SingleButtonStyled>
      {isDeleteButton && DeleteDialog()}
    </>
  );
}

export default SingleButton;
